import { post } from "../../helpers/api_helper";
import toast from "react-hot-toast";

function uploadAdapter(loader) {
  return {
    upload: () => {
      return new Promise((resolve, reject) => {
        const body = new FormData();
        loader.file.then(async (file) => {
          body.append("file", file);
          const uploadToast = toast.loading("Uploading...");

          console.log("body", body);
          try {
            const response = await post("home/upload", body);
            console.log("response", response);

            if (response?.success) {
              toast.success("Upload successful", { id: uploadToast });
              resolve({
                default: response?.data?.path,
              });
            } else {
              toast.error(response?.message || "Upload failed", {
                id: uploadToast,
              });
              reject(response?.message || "Upload failed");
            }
          } catch (err) {
            toast.error("Upload failed", { id: uploadToast });
            reject(err);
          }
        });
      });
    },
  };
}

export default uploadAdapter;
